import { SecondaryBookingInformation } from 'components/secondaryMarket/shared/sections/SecondaryBookingInformation';
import { secondaryMarketBookingInformationConnectFactory } from 'components/secondaryMarket/shared/sections/SecondaryBookingInformation.connect';
import { SecondaryProductSummary } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary';
import { secondaryMarketProductSummaryConnectFactory } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary.connect';
import { SecondaryTradeInformation } from 'components/secondaryMarket/shared/sections/SecondaryTradeInformation';
import { secondaryMarketTradeInformationConnectFactory } from 'components/secondaryMarket/shared/sections/SecondaryTradeInformation.connect';
import { connect } from 'react-redux';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import { liveFormInputSelectors } from 'state/secondaryMarket/live/form/input/inputForm.selectors';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

export const connectedLiveSections = (workspaceType: SecondaryWorkspaceType) => {
  const productSummaryConnectParams = secondaryMarketProductSummaryConnectFactory(
    liveReferentialSelectors,
    liveSelectors,
    liveThunks,
    workspaceType,
  );
  const tradeInformationConnectParams = secondaryMarketTradeInformationConnectFactory(
    liveReferentialSelectors,
    liveFormInputSelectors,
    liveSelectors,
    liveThunks,
    workspaceType,
  );

  const bookingInformationConnectParams = secondaryMarketBookingInformationConnectFactory(
    liveReferentialSelectors,
    liveSelectors,
    liveInputFormActions,
  );
  return {
    ConnectedProductSummary: connect(
      productSummaryConnectParams.mapStateToProps,
      productSummaryConnectParams.mapDispatchToProps,
    )(SecondaryProductSummary),
    ConnectedTradeInformation: connect(
      tradeInformationConnectParams.mapStateToProps,
      tradeInformationConnectParams.mapDispatchToProps,
    )(SecondaryTradeInformation),
    ConnectedBookingInformation: connect(
      bookingInformationConnectParams.mapStateToProps,
      bookingInformationConnectParams.mapDispatchToProps,
    )(SecondaryBookingInformation),
  };
};
